<template>
  <div class="invitation-income-conf">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit" @add="add" @delete="deleteRow"></ConfigTable>
    <EditIncomeConf ref="editDialog" @sure="callEdit"></EditIncomeConf>
  </div>
</template>

<script>
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import angentApi from '../../../api/angentManagement';
import EditIncomeConf from './components/EditIncomeConf.vue';

const searchConfig = [
  // { type: 'input', placeholder: '输入配置Id', key: 'id' },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
]
const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '名称', width: 220, key: 'name' },
  { name: '达成目标', key: 'finishCount' },
  { name: '收益率', key: 'incomeRate' },
  { name: '排序', key: 'sort' },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'CrowdfundRecord',
  components: { ConfigTable, EditIncomeConf },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await angentApi.getInvitationIncomeConfList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索众筹参与记录失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async deleteRow(row) {
      try {
        const r = await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await angentApi.delInvitationIncomeConf({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        const res = await (r.isEdit ? angentApi.updateInvitationIncomeConf(r.data) : angentApi.createInvitationIncomeConf(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {

      }
    },
  }
};
</script>

<style lang="scss" scoped>
.invitation-income-conf {}
</style>